import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=6f29ba5f&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=6f29ba5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f29ba5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f29ba5f')) {
      api.createRecord('6f29ba5f', component.options)
    } else {
      api.reload('6f29ba5f', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=6f29ba5f&scoped=true&", function () {
      api.rerender('6f29ba5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fdWbAyQ59AU3/JS/teamMember.vue"
export default component.exports